import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ILogsState } from './logs.state';

const selectLogs = createFeatureSelector<ILogsState>('logs');

export const getLog = createSelector(selectLogs, (state: ILogsState) => state.log);

export const getLogSuccess = createSelector(selectLogs, (state: ILogsState) => state.success);

export const getLogError = createSelector(selectLogs, (state: ILogsState) => state.error);

export const getLogs = createSelector(selectLogs, (state: ILogsState) => state.logs);

export const getPaginatedLogs = createSelector(selectLogs, (state: ILogsState) => state.paginatedLogs);
